export interface Movie {
  id: string;
  title: string;
  year: number;
  rating: number;
  genres: string[];
  region: string;
  duration: number;
  director: string;
  cast: string[];
  poster: string;
  backdrop: string;
  summary: string;
  synopsis: string[];
  tips: string;
  tags: string[];
  featured?: boolean;
}

export const movies: Movie[] = [
  {
    id: "deep-blue-night",
    title: "深蓝夜航",
    year: 2024,
    rating: 8.4,
    genres: ["惊悚", "悬疑"],
    region: "中国大陆",
    duration: 118,
    director: "陆川野",
    cast: ["沈未名", "周砚", "林知夏"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20pilot%20silhouette%20against%20a%20deep%20midnight%20blue%20sky%20with%20moonlight%2C%20moody%20suspense%20thriller%20tone%2C%20minimal%20typography%20space%2C%20high%20contrast%20dark%20atmosphere&width=600&height=900&seq=mm-poster-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=dark%20airplane%20cockpit%20at%20night%20over%20deep%20blue%20ocean%20with%20distant%20city%20lights%2C%20cinematic%20thriller%20mood%2C%20moody%20moonlight%2C%20film%20grain%2C%20wide%20establishing%20shot&width=1920&height=1080&seq=mm-back-01&orientation=landscape",
    summary: "一架午夜航班偏离航线，机长必须在无人知晓的深夜里做出选择。",
    synopsis: [
      "深夜两点十七分，一架从南方飞往北方的红眼航班突然与地面失去联系。机长陈默发现导航系统被一层无法关闭的蓝光包裹，屏幕上所有坐标都在缓慢偏移。",
      "机舱里只有九名乘客，每个人都藏着不愿说出口的往事。随着高度不断下降，陈默意识到这趟航班的终点从来不是目的地，而是一个被刻意抹去的夜晚。",
      "影片以近乎窒息的节奏推进，把恐惧藏在仪表盘的微光与人物的沉默之间，直到最后一刻才揭示那层深蓝色究竟意味着什么。",
    ],
    tips: "建议在完全安静的环境下观看，关掉所有多余光源，让屏幕的蓝色成为唯一的夜灯。前四十分钟节奏缓慢，请耐心等待——所有细节都会在结尾回收。",
    tags: ["午夜必看", "心理惊悚", "高分悬疑"],
    featured: true,
  },
  {
    id: "midnight-frequency",
    title: "午夜频率",
    year: 2023,
    rating: 7.9,
    genres: ["恐怖", "悬疑"],
    region: "美国",
    duration: 104,
    director: "Marcus Vale",
    cast: ["Elena Frost", "Daniel Rook", "Ivy Sanders"],
    poster: "https://readdy.ai/api/search-image?query=horror%20movie%20poster%20of%20an%20old%20radio%20tower%20glowing%20red%20at%20midnight%2C%20eerie%20fog%2C%20dark%20purple%20tones%2C%20dramatic%20contrast%2C%20minimal%20poster%20layout%2C%20uncanny%20atmosphere&width=600&height=900&seq=mm-poster-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=isolated%20radio%20station%20in%20a%20dark%20forest%20at%20night%2C%20eerie%20red%20glow%2C%20fog%20and%20shadow%2C%20horror%20cinematography%2C%20wide%20shot%2C%20moody%20dark%20purple%20atmosphere&width=1920&height=1080&seq=mm-back-02&orientation=landscape",
    summary: "深夜电台里，一个不该存在的频率每晚准时响起。",
    synopsis: [
      "电台主播玛拉接手的是一档无人问津的凌晨档节目。第三个夜晚，她在调频时捕捉到一个没有任何台标的频率，里面播放着她从未录过的节目。",
      "听众开始打电话进来，讲述那些本应只有玛拉才知道的私事。她逐渐明白，那个频率并不在广播里，而在每个深夜失眠者的脑海中。",
      "当录音棚的灯光第一次无法被关掉，玛拉终于听见了那个用她自己声音说出的话。",
    ],
    tips: "戴耳机观看效果翻倍，但不建议独居者凌晨观看。影片音效设计极为克制，注意那些突然消失的环境声。",
    tags: ["午夜必看", "电台恐怖", "沉浸音效"],
    featured: true,
  },
  {
    id: "moonlight-diner",
    title: "月光餐馆",
    year: 2022,
    rating: 8.7,
    genres: ["剧情", "爱情"],
    region: "日本",
    duration: 126,
    director: "中村凛",
    cast: ["佐藤遥", "木村拓真的", "松本绫"],
    poster: "https://readdy.ai/api/search-image?query=warm%20cinematic%20movie%20poster%20of%20a%20tiny%20late%20night%20diner%20with%20warm%20amber%20light%2C%20lonely%20figure%20sitting%20at%20the%20counter%2C%20gentle%20melancholy%20mood%2C%20soft%20film%20photography%20style&width=600&height=900&seq=mm-poster-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cozy%20late%20night%20diner%20interior%20with%20warm%20amber%20lights%20and%20steaming%20food%2C%20gentle%20melancholic%20cinematic%20lighting%2C%20shallow%20depth%20of%20field%2C%20soft%20film%20texture&width=1920&height=1080&seq=mm-back-03&orientation=landscape",
    summary: "只有在凌晨营业的小餐馆里，陌生人交换着各自未完成的告别。",
    synopsis: [
      "城市角落有一家只在午夜到天亮营业的小餐馆，老板从不问客人的名字，只记得他们常点的菜。",
      "一位失去丈夫的女士、一位即将离乡的年轻人、一位总点同一碗面的老人，在这个夜晚先后走进来，用一顿饭的时间讲完了各自没说出口的告别。",
      "影片没有激烈的冲突，温柔得像一碗深夜的热汤，却在结尾让人突然想起某个自己想念的人。",
    ],
    tips: "适合独自观看，或与愿意陪你沉默的人一起。备好纸巾和一份夜宵，效果最佳。",
    tags: ["治愈系", "深夜食堂", "高分剧情"],
    featured: true,
  },
  {
    id: "seventh-night-shift",
    title: "第七个夜班",
    year: 2024,
    rating: 8.1,
    genres: ["惊悚", "犯罪"],
    region: "韩国",
    duration: 112,
    director: "朴正勋",
    cast: ["金秀赫", "李恩彬", "崔敏书"],
    poster: "https://readdy.ai/api/search-image?query=tense%20thriller%20movie%20poster%20of%20an%20empty%20hospital%20corridor%20at%20night%20lit%20by%20cold%20green%20fluorescence%2C%20lone%20security%20guard%20silhouette%2C%20eerie%20empty%20atmosphere%2C%20dark%20moody&width=600&height=900&seq=mm-poster-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=empty%20hospital%20corridor%20at%20midnight%20with%20flickering%20lights%2C%20cold%20atmosphere%2C%20cinematic%20thriller%20wide%20shot%2C%20deep%20shadows%2C%20tense%20dark%20mood&width=1920&height=1080&seq=mm-back-04&orientation=landscape",
    summary: "保安的第七个夜班，大楼里多出了一个不在名单上的房间。",
    synopsis: [
      "退伍军人贤秀找了一份夜间保安的工作，负责一栋即将拆迁的旧写字楼。头几个夜晚平淡无事，直到第七天，他在监控里发现一间本不存在的房间亮起了灯。",
      "随着夜班继续，那间屋子里的东西开始出现在走道尽头。贤秀试图上报，却发现所有记录里都没有他的第七个夜班。",
      "影片用极简的场景制造出持续攀升的压迫感，把职场与恐惧巧妙地叠在了一起。",
    ],
    tips: "适合喜欢低预算高张力惊悚片的观众。注意走道里的镜面反射，很多线索藏在画面角落。",
    tags: ["午夜必看", "单场景惊悚", "监控视角"],
    featured: true,
  },
  {
    id: "neon-afterimage",
    title: "霓虹残影",
    year: 2023,
    rating: 8.0,
    genres: ["科幻", "悬疑"],
    region: "中国香港",
    duration: 121,
    director: "黄启铭",
    cast: ["梁乐", "苏晚晴", "何俊"],
    poster: "https://readdy.ai/api/search-image?query=cyberpunk%20movie%20poster%20of%20a%20rainy%20neon%20city%20street%20at%20night%20with%20reflections%20of%20orange%20and%20purple%20signs%2C%20lone%20silhouette%20walking%20away%2C%20cinematic%20sci-fi%20noir%20tone&width=600&height=900&seq=mm-poster-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=rain%20slicked%20neon%20city%20street%20at%20midnight%20with%20warm%20orange%20and%20violet%20signage%2C%20blade%20runner%20style%20cinematic%20sci-fi%20noir%2C%20reflections%20on%20wet%20asphalt%2C%20moody%20atmosphere&width=1920&height=1080&seq=mm-back-05&orientation=landscape",
    summary: "记忆可以被删除的年代，一名侦探追查自己制造的一桩旧案。",
    synopsis: [
      "在近未来的香港，记忆可以被合法擦除。私人侦探程野接下一个寻找失踪女孩的委托，却在调查中发现案件的每一条线索都指向被抹去的自己。",
      "为了拼回真相，他不得不反复回到那个雨夜，看同一段霓虹在积水里碎开又重合。每找回一段记忆，就失去另一段。",
      "影片以浓烈的视觉风格包裹一个关于身份与悔意的内核，结尾那句台词足以让人久久无言。",
    ],
    tips: "画面信息量很大，建议关灯后用大屏观看。第一次看容易被霓虹吸走注意力，值得二刷去找伏笔。",
    tags: ["视觉系", "赛博迷城", "午夜必看"],
    featured: true,
  },
  {
    id: "sleepless-city",
    title: "无眠之城",
    year: 2022,
    rating: 7.8,
    genres: ["剧情", "犯罪"],
    region: "中国大陆",
    duration: 133,
    director: "沈望川",
    cast: ["程野", "赵立衡", "林知夏"],
    poster: "https://readdy.ai/api/search-image?query=moody%20crime%20drama%20movie%20poster%20of%20an%20empty%20city%20overpass%20at%20night%20with%20orange%20street%20lamps%2C%20lone%20figure%20leaning%20on%20the%20railing%2C%20melancholic%20urban%20noir&width=600&height=900&seq=mm-poster-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=empty%20city%20highway%20overpass%20at%20midnight%20with%20orange%20streetlights%20and%20distant%20skyline%2C%20urban%20noir%20cinematography%2C%20lonely%20moody%20atmosphere&width=1920&height=1080&seq=mm-back-06&orientation=landscape",
    summary: "城市的夜晚从不入睡，巡夜的警察却在寻找一个能安睡的理由。",
    synopsis: [
      "老警察陈松柏负责的片区有一桩悬而未决的旧案，嫌疑人早已出狱，受害者家属却始终没能等到答案。",
      "一个失眠的夜晚，他在巡逻中再次遇见当年案件里的每一个人，他们都还醒着，都被同一件事困在夜里。",
      "影片像一场漫长的夜巡，把城市、责任与和解铺陈在凌晨的路灯下。",
    ],
    tips: "节奏偏慢的现实主义犯罪片，适合睡前一小时静看。片尾没有反转，但后劲很大。",
    tags: ["都市 noir", "现实主义", "深夜巡游"],
  },
  {
    id: "echo-dark-alley",
    title: "暗巷回声",
    year: 2024,
    rating: 7.6,
    genres: ["恐怖", "惊悚"],
    region: "欧洲",
    duration: 98,
    director: "Clara Bennett",
    cast: ["Sophie Lane", "Julian Marsh", "Anna Voss"],
    poster: "https://readdy.ai/api/search-image?query=creepy%20horror%20movie%20poster%20of%20a%20narrow%20cobblestone%20alley%20at%20midnight%20with%20a%20distant%20flickering%20lamp%2C%20lone%20figure%20walking%20into%20deep%20shadow%2C%20cold%20teal%20and%20black%20tones%2C%20eerie%20fog&width=600&height=900&seq=mm-poster-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=old%20european%20cobblestone%20alley%20at%20midnight%20with%20fog%20and%20a%20single%20flickering%20street%20lamp%2C%20gothic%20horror%20atmosphere%2C%20cold%20desaturated%20tones%2C%20tense%20wide%20shot&width=1920&height=1080&seq=mm-back-07&orientation=landscape",
    summary: "一条走不出去的老巷子，每晚都会重复你昨晚说过的话。",
    synopsis: [
      "旅人汉娜误入一座古城，被导航带进一条地图上不存在的巷子。无论往哪个方向走，她都会回到同一盏路灯下。",
      "更诡异的是，巷子会把她白天说过、想过的话，用另一个声音原样还给她。随着回声越来越多，她开始分不清哪句是自己说的。",
      "影片用极简的场景和声音设计营造出心理层面的恐怖，结局开放而令人不安。",
    ],
    tips: "这是典型的“声音恐怖”片，推荐夜戴耳机。剧情留白较多，喜欢解释清楚一切的观众慎入。",
    tags: ["心理恐怖", "欧陆小巷", "声音设计"],
  },
  {
    id: "letter-at-four-am",
    title: "凌晨四点的信",
    year: 2021,
    rating: 8.2,
    genres: ["剧情", "爱情"],
    region: "中国大陆",
    duration: 107,
    director: "苏晚",
    cast: ["林知夏", "周砚", "程野"],
    poster: "https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20of%20a%20young%20woman%20writing%20a%20letter%20by%20a%20window%20at%20dawn%2C%20soft%20blue%20predawn%20light%2C%20delicate%20melancholic%20mood%2C%20gentle%20film%20texture&width=600&height=900&seq=mm-poster-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=quiet%20apartment%20room%20at%20four%20am%20with%20soft%20predawn%20blue%20light%20through%20the%20window%2C%20papers%20and%20a%20desk%20lamp%2C%20tender%20melancholic%20cinematography&width=1920&height=1080&seq=mm-back-08&orientation=landscape",
    summary: "她每天凌晨四点写信，寄给一个从不会回信的人。",
    synopsis: [
      "自由撰稿人知夏保持着每天凌晨四点写一封信的习惯，收信人是她三年前不告而别的恋人。她从没寄出过这些信，只是把它们锁进抽屉。",
      "直到某天，一封回信出现在邮箱里，笔迹是对方的，邮戳却是她所在的城市、今天的日期。",
      "影片在两座城市之间往返，讲述一段迟到太久的告白，也讲述了如何与过去的自己和解。",
    ],
    tips: "适合深夜独自观看。建议看完立刻给一个你想念的人发条消息，别学主角把话留到凌晨四点。",
    tags: ["深夜爱情", "治愈系", "高分剧情"],
  },
  {
    id: "the-taxidermist",
    title: "标本师",
    year: 2023,
    rating: 7.4,
    genres: ["恐怖", "剧情"],
    region: "美国",
    duration: 101,
    director: "Nathan Cole",
    cast: ["Owen Pryce", "Mara Nolan", "Theo Grant"],
    poster: "https://readdy.ai/api/search-image?query=dark%20horror%20movie%20poster%20of%20a%20taxidermy%20workshop%20with%20a%20lone%20dim%20lamp%2C%20stuffed%20animals%20in%20shadow%2C%20dust%20in%20the%20air%2C%20ominous%20brown%20and%20black%20palette%2C%20uncanny%20stillness&width=600&height=900&seq=mm-poster-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cluttered%20old%20taxidermy%20workshop%20at%20night%20lit%20by%20a%20single%20dim%20bulb%2C%20rows%20of%20stuffed%20animals%20in%20shadow%2C%20dusty%20eerie%20atmosphere%2C%20horror%20cinematography&width=1920&height=1080&seq=mm-back-09&orientation=landscape",
    summary: "小镇标本师接了一单生意，客人却要求保留“还活着”的部分。",
    synopsis: [
      "在偏僻小镇经营标本作坊的埃尔文手艺精湛，却沉默寡言。一天，一位客人带来一只从未见过的动物，要求他把它做成“还在呼吸的样子”。",
      "随着工作推进，作坊里的标本开始出现在不该出现的位置，而客人的身份也越来越可疑。埃尔文发现，自己或许并不是唯一在“保留”某些东西的人。",
      "影片把恐怖与工整的手艺形成强烈反差，安静得令人发毛。",
    ],
    tips: "如果你怕小动物或标本，请谨慎观看。影片没有大量惊吓，恐怖来自持续的怪异安静。",
    tags: ["怪奇美学", "小镇恐怖", "慢热"],
  },
  {
    id: "flying-against-light",
    title: "逆光飞行",
    year: 2024,
    rating: 8.3,
    genres: ["剧情"],
    region: "中国大陆",
    duration: 124,
    director: "陆川野",
    cast: ["沈未名", "赵立衡", "苏晚晴"],
    poster: "https://readdy.ai/api/search-image?query=inspirational%20drama%20movie%20poster%20of%20a%20silhouette%20spreading%20arms%20against%20a%20warm%20amber%20sunset%20sky%2C%20sense%20of%20freedom%20and%20hope%2C%20cinematic%20minimal%20composition%20with%20generous%20negative%20space&width=600&height=900&seq=mm-poster-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20person%20standing%20on%20a%20cliff%20against%20a%20glowing%20amber%20dusk%20sky%2C%20cinematic%20emotional%20wide%20shot%2C%20warm%20golden%20light%2C%20hopeful%20atmosphere&width=1920&height=1080&seq=mm-back-10&orientation=landscape",
    summary: "一个被地面困住的人，学会了在夜里逆着光飞。",
    synopsis: [
      "曾经的飞行学员江野因一场事故失去资格，回到小城做起了夜间货运。一次偶然的试飞机会，让他重新面对当年那场事故里没能说出口的真相。",
      "整个故事发生在一年中最短的几个夜晚里，江野必须在别人放弃他之前，先学会不放弃自己。",
      "影片用克制的镜头语言讲述了一个关于重启的普通人的故事，结尾的起飞戏令人热泪盈眶。",
    ],
    tips: "适合低谷期观看，看完会想立刻做点什么。没有狗血逆袭，只有一次次默默坚持。",
    tags: ["治愈系", "励志", "高分剧情"],
  },
  {
    id: "vinyl-riddle",
    title: "黑胶迷局",
    year: 2022,
    rating: 7.7,
    genres: ["悬疑", "犯罪"],
    region: "中国香港",
    duration: 116,
    director: "黄启铭",
    cast: ["梁乐", "何俊", "苏晚晴"],
    poster: "https://readdy.ai/api/search-image?query=noir%20mystery%20movie%20poster%20of%20a%20spinning%20vinyl%20record%20under%20warm%20amber%20light%20in%20a%20dark%20room%2C%20smoke%20in%20the%20air%2C%20retro%20detective%20mood%2C%20rich%20shadow&width=600&height=900&seq=mm-poster-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=dim%20retro%20record%20shop%20at%20night%20with%20rows%20of%20vinyl%20and%20warm%20amber%20lamps%2C%20noir%20detective%20atmosphere%2C%20smoke%20and%20shadow%2C%20cinematic%20depth&width=1920&height=1080&seq=mm-back-11&orientation=landscape",
    summary: "一张旧唱片里的背景噪音，录下了二十年前的一桩罪案。",
    synopsis: [
      "旧唱片收藏家阿铭在一张绝版黑胶的背景杂音里，听见了一段被意外录下的人声争吵，内容涉及一桩早已结案的失踪案。",
      "为了弄清真相，他循着唱片上的编号，走进了一个由旧唱片、旧关系和旧秘密组成的地下世界。",
      "影片节奏沉稳、对白讲究，是用声音破案的悬疑佳作。",
    ],
    tips: "细节控会爱上这部片。对白含有方言，建议开中文字幕；听歌识曲的片段别快进。",
    tags: ["硬盘迷案", "怀旧美学", "悬疑推理"],
  },
  {
    id: "endless-night-party",
    title: "永夜派对",
    year: 2024,
    rating: 7.5,
    genres: ["惊悚", "黑色幽默"],
    region: "欧洲",
    duration: 95,
    director: "Clara Bennett",
    cast: ["Sophie Lane", "Theo Grant", "Anna Voss"],
    poster: "https://readdy.ai/api/search-image?query=dark%20comedy%20thriller%20movie%20poster%20of%20a%20luxury%20rooftop%20party%20at%20night%20with%20warm%20orange%20lights%2C%20elegant%20silhouettes%20dancing%2C%20subtle%20unease%20beneath%20glamour%2C%20rich%20cinematic%20tones&width=600&height=900&seq=mm-poster-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=elegant%20rooftop%20party%20at%20midnight%20with%20warm%20amber%20string%20lights%20and%20city%20skyline%2C%20glamorous%20yet%20slightly%20menacing%20cinematic%20atmosphere%2C%20dark%20comedy%20mood&width=1920&height=1080&seq=mm-back-12&orientation=landscape",
    summary: "一场永不结束的派对，宾客们开始怀疑自己是否还记得为何而来。",
    synopsis: [
      "一栋顶层公寓里的派对已经持续了整整一周，音乐不停、香槟不断，没有人离场，也没有人记得是谁发出的邀请。",
      "随着时间失去意义，宾客们渐渐暴露出各自来这里的真实目的，而派对的主人始终没有现身。",
      "影片用华丽外壳包裹一层冷冽的黑色幽默，关于社交、虚荣与逃脱。",
    ],
    tips: "黑色幽默偏冷，笑点需要细品。适合与朋友边聊边看，观影后很适合讨论“你会留下吗”。",
    tags: ["黑色幽默", "社交寓言", "迷幻"],
  },
];